import React from 'react';
import { CommonIconProps } from './Icon';

const ChevronRightIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.35982 7.76825C7.93554 7.41468 7.87822 6.78412 8.23178 6.35984C8.58535 5.93556 9.21591 5.87824 9.64019 6.2318L15.625 11.2191C15.6534 11.242 15.6809 11.2665 15.7072 11.2929C15.7898 11.3753 15.8553 11.4694 15.9032 11.5703C15.9682 11.7066 16.0001 11.8536 16 12C16.0001 12.1465 15.9682 12.2935 15.9032 12.4298C15.8553 12.5306 15.7898 12.6247 15.7072 12.7072C15.6809 12.7335 15.6534 12.7581 15.625 12.7809L9.64019 17.7682C9.21591 18.1218 8.58535 18.0645 8.23178 17.6402C7.87822 17.2159 7.93554 16.5854 8.35982 16.2318L13.438 12L8.35982 7.76825Z"
      fill={color}
    />
  </>
);

export default ChevronRightIcon;
